import CompanyStatCard from '../../components/CompanyStatCard';

const HealthStatCard = ({ additionalData, isLoading }) => {
    const { healthSummary = {} } = additionalData;

    return (
        <div className="flex gap-4 mb-6 text-center">
            <CompanyStatCard
                className="items-center!"
                title="Healthy"
                value={healthSummary.healthy}
                isLoading={isLoading}
            />
            <CompanyStatCard
                className="items-center!"
                title="At Risk"
                value={healthSummary.atRisk}
                isLoading={isLoading}
            />
            <CompanyStatCard
                className="items-center!"
                title="Critical"
                value={healthSummary.critical}
                isLoading={isLoading}
            />
        </div>
    )
}

export default HealthStatCard